var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"addToProjectHint"},[_vm._v("\n    Bitte gewünschten Beitrag zum Hinzufügen zum Projekt anklicken.\n  ")]),_vm._v(" "),_c('div',{staticClass:"addToProjectHintAbort",on:{"click":function($event){_vm.$emit('closeSelectionMap')}}},[_c('svgicon',{attrs:{"icon":'close',"width":"32","height":"32","color":"#fff"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f8f08c4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddToProjectHint.vue
// module id = null
// module chunks = 